// extracted by mini-css-extract-plugin
export default {"containerTitle":"containerTitle_W6PP5","title":"title_CmJBs","more":"more_Rej96"};